// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"policy_maincontainer__5efig","policy":"policy_policy__SiHjw"};